/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js"

import router from '@/router'

export default {
    loginAttempt({ dispatch }, payload) {

        // New payload for login action
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            closeAnimation: payload.closeAnimation,
            self: payload.self
        }
          dispatch('login', newPayload)
        
    },
    login({ commit, state, dispatch }, payload) {
        localStorage.clear();
        localStorage.setItem('permissions', '');
        localStorage.setItem('userName', '');
        localStorage.setItem('uId', '');
        localStorage.setItem('uEmail', '');
        localStorage.setItem('accountKey', '');
        localStorage.setItem('userAccount','');
        localStorage.setItem('homeScreenMessage', '');

        if (state.isUserLoggedIn()) {
            // Close animation if passed as payload
            if(payload.closeAnimation) payload.closeAnimation()

            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            //router.push(router.currentRoute.query.to || '/selectaccount')
            return false
        }
        payload.self.$signIn(payload.self, payload.userDetails.uid,payload.userDetails.email, payload.userDetails.password, (result) => {
          var self = this;
          var data = result.value;
            let isUsernameUpdateRequired = false                   // Set FLAG username update required for updating username
            localStorage.setItem('userInfo', JSON.stringify(data)); //localstorage store information across the application
            var userInfo = JSON.parse(localStorage.getItem('userInfo'));
            sessionStorage.accessToken = data[0].token;                //set the user's token store information across the application
            payload.userDetails.displayName = userInfo[0].userName;
            sessionStorage.username = userInfo[0].userRoles.username;
            sessionStorage.roles = JSON.stringify(userInfo[0].userRoles);
            sessionStorage.guID = payload.userDetails.uid;            
            
            var myRoles = JSON.parse(sessionStorage.roles).userRoles.map(x=> x.code)
            payload.self.$acl.change(myRoles);
            localStorage.setItem("userAccountInfo", JSON.stringify(data));
            localStorage.setItem('userId', userInfo[0].userRoles.id);
            localStorage.setItem('userName', userInfo[0].userRoles.username);
            localStorage.setItem('userKey', userInfo[0].userKey);
            state.userId = userInfo[0].userRoles.id;
            state.userName = userInfo[0].userRoles.username;
            state.userKey = userInfo[0].userKey;
            
           //debugger;
            //Andre 20202-11-21
            //If client only has 1 x account, navigate straight to dashboard
            if(userInfo.length == 1){
              //Code copied from account selected
              //Andre 2020-11-22
              if(userInfo[0].userRoles.id > 1 && userInfo[0].account.blocked == false){
                var selected = [{
                  accountKey: userInfo[0].account.accountKey,
                  accountName: userInfo[0].account.accountName,
                  accountId: userInfo[0].account.accountId
                }];
                
                localStorage.setItem("userAccountSelected", JSON.stringify(selected));
                localStorage.setItem('userAccount',userInfo[0].account.accountName);
                localStorage.setItem('userAccountId',userInfo[0].account.accountId);
                localStorage.setItem('userAccountKey',userInfo[0].account.accountKey);
                localStorage.setItem('homeScreenMessage', userInfo[0].homeScreenMessage);

                localStorage.setItem('userAccountTypeId',userInfo[0].account.accountTypeId);
                localStorage.setItem('userAccountType',userInfo[0].account.accountType);
                state.accountTypeId = userInfo[0].account.accountTypeId;
                state.accountType = userInfo[0].account.accountType;
  
                state.accountName = userInfo[0].account.accountName;
                state.accountId = userInfo[0].account.accountId;
                state.accountKey = userInfo[0].account.accountKey;
                router.push('/dashboard/analytics');
              }
              else{
                payload.notify({
                  title: 'Login Attempt',
                  text: 'Account not found or blocked!',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                });
              }
              
            } else {
              router.push('/selectaccount');
            }
            payload.self.$vs.loading.close(payload.self.$refs.login.$el);

            if(payload.updateUsername && payload.userDetails.displayName) {
              isUsernameUpdateRequired = true
              dispatch('updateUsername', {
              user: dataresult.user,
              username: payload.userDetails.displayName,
              notify: payload.notify,
              isReloadRequired: true
              })
          }
        // var success = function(result) {
        //         var dataresult = result;
        //         var providerData = result.user.providerData[0];
        //         payload.userDetails.uid = result.user.uid;
        //         localStorage.setItem('uId', result.user.uid);
        //         localStorage.setItem('uEmail', result.user.email);
        //         //NOW DO FAM
                
                   //   // if username update is not required
                      //   // just reload the page to get fresh data
                      //   // set new user data in localstorage
                      // if(!isUsernameUpdateRequired) {
                      //   router.push(router.currentRoute.query.to || '/')
                      //  //router.push('/dashboard/analytics')
                      //   commit('UPDATE_USER_INFO', providerData, {root: true})
                      //   }


                  // payload.self.$vs.loading.close(payload.self.$refs.login.$el);
                  if(payload.closeAnimation) payload.closeAnimation()

                  // if(payload.closeAnimation) payload.closeAnimation()
                  //   //FAMS succesfully logged in
                  //   //Now get account
                  //   payload.self.$getAccount(self, function () {
                  //         // payload.self.$setPermissions(self, function () {
                  //         //   
                  //         //   if (localStorage.getItem('permissions').includes("Student")) {
                  //         //     router.push('/menu');
                  //         //   } else
                  //         //     router.push(router.currentRoute.query.to || '/');
                  //         //   payload.self.$vs.loading.close(payload.self.$refs.login.$el);
                  //         // });
                  //         router.push(router.currentRoute.query.to || '/');
                  //         payload.self.$vs.loading.close(payload.self.$refs.login.$el);
                  //         if(payload.closeAnimation) payload.closeAnimation()
                  //     });

                     //payload.self.$vs.loading.close(payload.self.$refs.login.$el);

                    // var data = result;
                    // var localStorageString = JSON.stringify(data);
                    // localStorage.setItem('userInfo', localStorageString);
                    // sessionStorage.accessToken = data.apiToken;

                        
                       
                        // if username is provided and updateUsername FLAG is true
                        // set local username update FLAG to true
                        // try to update username
                        // if(payload.updateUsername && payload.userDetails.displayName) {

                        //     isUsernameUpdateRequired = true

                        //     dispatch('updateUsername', {
                        //     user: dataresult.user,
                        //     username: payload.userDetails.displayName,
                        //     notify: payload.notify,
                        //     isReloadRequired: true
                        //     })
                        // }
                        // Close animation if passed as payload
                        if(payload.closeAnimation) payload.closeAnimation()

                     

                });
              //   if(payload.closeAnimation) payload.closeAnimation()
              //   payload.notify({
              //     time: 2500,
              //     title: 'Error',
              //     text: err.message,
              //     iconPack: 'feather',
              //     icon: 'icon-alert-circle',
              //     color: 'danger'
              // });
              // router.push(router.currentRoute.query.to || '/pages/login');
            
            
            var error = function(err){

                // Close animation if passed as payload
                if(payload.closeAnimation) payload.closeAnimation()

                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            };

        
            // Try to sigin
            var authPayload = {
              username: payload.userDetails.email,
              password: payload.userDetails.password,
            }
            //payload.self.$ajaxPost(payload.self, "skaap",authPayload, success, error);
            //firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password).then(success).catch(error);


    },
    updateUsername({ commit }, payload) {
        payload.user.updateProfile({
            displayName: payload.displayName
        }).then(() => {

            // If username update is success
              // update in localstorage
            let newUserData = Object.assign({}, payload.user.providerData[0])
            newUserData.displayName = payload.displayName
            commit('UPDATE_USER_INFO', newUserData, {root: true})

            // If reload is required to get fresh data after update
              // Reload current page
            if(payload.isReloadRequired) {
                //router.push(router.currentRoute.query.to || '/')
            }
        }).catch((err) => {
              payload.notify({
                time: 8800,
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
        })
    },


    // JWT
    loginJWT({ commit }, payload) {
      return new Promise((resolve,reject) => {
        jwt.login(payload.userDetails.email, payload.userDetails.password)
          .then(response => {

            // If there's user data in response
            if(response.data.userData) {
              // Navigate User to homepage
              //router.push(router.currentRoute.query.to || '/')

              // Set accessToken
              localStorage.setItem("accessToken", response.data.accessToken)

              // Update user details
              commit('UPDATE_USER_INFO', response.data.userData, {root: true})

              // Set bearer token in axios
              commit("SET_BEARER", response.data.accessToken)

              resolve(response)
            }else {
              reject({message: "Wrong Email or Password"})
            }

          })
          .catch(error => { reject(error) })
      })
    },
//     registerUserJWT({ commit }, payload) {

//       const { displayName, email, password, confirmPassword } = payload.userDetails

//       return new Promise((resolve,reject) => {

//         // Check confirm password
//         if(password !== confirmPassword) {
//           reject({message: "Password doesn't match. Please try again."})
//         }

//         jwt.registerUser(displayName, email, password)
//           .then(response => {
//             // Redirect User
//             //router.push(router.currentRoute.query.to || '/')
// entRoute.query.to || '/')

//             // Update data in localStorage
//             localStorage.setItem("accessToken", response.data.accessToken)
//             commit('UPDATE_USER_INFO', response.data.userData, {root: true})

//             resolve(response)
//           })
//           .catch(error => { reject(error) })
//       })
//     },
    fetchAccessToken() {
      return new Promise((resolve) => {
        jwt.refreshToken().then(response => { resolve(response) })
      })
    }

    // updateAuthenticatedUser({ commit }, payload) {
    //   commit('UPDATE_AUTHENTICATED_USER', payload)
    //   payload.self.$vs.loading.close(payload.self.$refs.login.$el);
    // }
}
